// One row of the report-detail dimension panel. The page's signature element.
// Uses the .dim / .dim-track / .dim-fill / .dim-val classes from global.css.

import { dimFillVariant, scoreLabel } from "../lib/scoring";

export function DimensionBar({
  name,
  score,
  label,
}: {
  name: string;
  score: number;
  /** Optional override; defaults to client-side scoreLabel. */
  label?: string;
}) {
  const variant = dimFillVariant(score);
  const fillClass = variant ? `dim-fill ${variant}` : "dim-fill";
  const widthPct = Math.max(0, Math.min(100, score));
  return (
    <div className="dim">
      <span className="dim-name">{name}</span>
      <div className="dim-track">
        <div className={fillClass} style={{ width: `${widthPct}%` }} />
      </div>
      <span className="dim-val">
        {Math.round(score)}
        <span className="l">{label ?? scoreLabel(score)}</span>
      </span>
    </div>
  );
}
